import { LANGUAGE_CODES } from "../enumerators/commons";

export const DEFAULT_LANGUAGE_CODE = LANGUAGE_CODES.ES;
